"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RandoAi = void 0;
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const AbilityArgs_1 = require("../../core/abilities/AbilityArgs");
const maps_1 = require("../../core/maps");
const Record_1 = require("../../utils/Record");
const AbilityType_1 = require("../../core/abilities/AbilityType");
const core_1 = require("../../core/actions/core");
let RandoAi = class RandoAi {
    init(sequence, container, state) { }
    handleEvent(sequence, container, state, e) { }
    nextTurn(sequence, container, state) {
        const enemies = container.selectLivingTargets(state.selfId, Target_1.Target.AllEnemies);
        const allies = container.selectLivingTargets(state.selfId, Target_1.Target.AllAllies);
        const ability = (0, Random_1.randomElement)(container.getEquippedAbilitySlots(state.selfId)
            .map(slot => container.getAbilityInSlot(state.selfId, slot))
            .filter(ability => !(0, Record_1.hasValue)(maps_1.PassiveOnlyAbility, AbilityType_1.AbilityType[ability.abilityType])
            && !ability.disabled
            && (ability.maxUses < 0 || ability.invokeCounter < ability.maxUses)));
        if (!ability) {
            container.dispatch(sequence, state.selfId, new core_1.DoNothingActionArgs());
            return;
        }
        let target = Target_1.Target.None;
        switch (ability.targetType) {
            case "Self":
                target = Target_1.Target.Self;
                break;
            case "OneEnemies":
                target = Target_1.Target.OneEnemy((0, Random_1.randomElement)(enemies));
                break;
            case "AllEnemies":
                target = Target_1.Target.AllEnemies;
                break;
            case "OneAllies":
                target = Target_1.Target.OneAlly((0, Random_1.randomElement)(allies));
                break;
            case "AllAllies":
                target = Target_1.Target.AllAllies;
                break;
        }
        const args = AbilityArgs_1.AbilityArgs.FromTypeName(ability.abilityType, target);
        return container.useAbility(sequence, state.selfId, args, true);
    }
};
RandoAi = __decorate([
    Registries_1.Ai.register("Rando")
], RandoAi);
exports.RandoAi = RandoAi;
